import { render } from "./PeopleToFollowUp.vue?vue&type=template&id=572ad335&scoped=true"
import script from "./PeopleToFollowUp.vue?vue&type=script&lang=js"
export * from "./PeopleToFollowUp.vue?vue&type=script&lang=js"

import "./PeopleToFollowUp.vue?vue&type=style&index=0&id=572ad335&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572ad335"]])

export default __exports__